import React from 'react';
import { useNavigate } from '@reach/router';
import { Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import DialogContent from '@material-ui/core/DialogContent';
import DrawerPwa from '../../../components/DrawerPwa';
import DialogBox from '../../../components/DialogBox';
// import { Badge } from '../../../components/Icons';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import css from './index.module.scss';

export default function AmtAlertPopUp({
  setAmtAlert,
  isDesktop,
  menu,
  amountObj,
  sugguestedAmount,
  countryValidations,
  defaultPath,
}) {
  const navigate = useNavigate();
  const dismissPopup = () => {
    setAmtAlert(false);
  };

  const handleExploreMenu = () => {
    setAmtAlert(false);
    navigate(defaultPath);
  };
  let calcAmount;
  if (sugguestedAmount !== 0) {
    calcAmount = decimalChecker(sugguestedAmount);
  } else {
    calcAmount = decimalChecker(countryValidations?.minOrderAmount - amountObj[0]?.amount);
  }

  const renderInnerPopUp = () => {
    return (
      <DialogContent dividers={true}>
        <div className={css.container}>
          {/* <div className={css.badge}>
            <Badge />
          </div> */}
          <div className={css.smallHeading}>
            <FormattedMessage id="minimun_order" defaultMessage="Minimun Order" />
          </div>
          <p>
            <FormattedMessage id="minimum_amount_description1" defaultMessage="Add items worth" />
            <span>{`${calcAmount} ${countryValidations?.currency || ''}`}</span>
            <FormattedMessage
              id="minimum_amount_description2"
              defaultMessage=" more to proceed with this order."
            />
          </p>
          <div className={css.buttons}>
            <Button onClick={dismissPopup} variant="outlined" color="primary" className={css.close}>
              <FormattedMessage id="cartDismiss" default="Dismiss" />
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleExploreMenu}
              className={css.submit}
            >
              <FormattedMessage id="cart_exploremenu" default="Explore Menu" />
            </Button>
          </div>
        </div>
      </DialogContent>
    );
  };
  return (
    <React.Fragment>
      {!isDesktop ? (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={true}
          className={css.nobg}
          onClose={dismissPopup}
        >
          {renderInnerPopUp()}
        </DrawerPwa>
      ) : (
        <DialogBox size="sm" isOpen={true} onClose={dismissPopup}>
          {renderInnerPopUp()}
        </DialogBox>
      )}
    </React.Fragment>
  );
}
